export default __webpack_public_path__ + "static/media/logo-gray.ea83beb8.svg";